import { render, staticRenderFns } from "./availabilityDetails.vue?vue&type=template&id=71865bf4&scoped=true"
import script from "./availabilityDetails.vue?vue&type=script&lang=js"
export * from "./availabilityDetails.vue?vue&type=script&lang=js"
import style0 from "./availabilityDetails.vue?vue&type=style&index=0&id=71865bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71865bf4",
  null
  
)

export default component.exports